import { TenantSystemSettings } from '../models/tenant-system-settings';

export const TENANT_TOGGLEABLE_SYSTEM_FIELDS = {
  gender: 'gender',
  races: 'races',
  linkedInProfile: 'linkedInProfile'
} as const;

export function isSystemFieldEnabled(fieldId: string, visibility: TenantSystemSettings): boolean {
  if (!visibility || !fieldId) return true;
  switch (fieldId) {
    case TENANT_TOGGLEABLE_SYSTEM_FIELDS.gender:
      return visibility.isGenderFieldEnabled;
    case TENANT_TOGGLEABLE_SYSTEM_FIELDS.races:
      return visibility.isRaceFieldEnabled;
    case TENANT_TOGGLEABLE_SYSTEM_FIELDS.linkedInProfile:
      return visibility.isLinkedInFieldEnabled;
    default:
      return true;
  }
}

export function filterBySystemFieldVisibility<
  T extends { targetField?: string; childFieldName?: string; id?: string }
>(items: T[], visibility: TenantSystemSettings): T[] {
  if (!visibility) return items;
  return items.filter((item) => {
    const fieldIds = [item.targetField, item.childFieldName, item.id].filter(Boolean);
    return fieldIds.every((fieldId) => isSystemFieldEnabled(fieldId, visibility));
  });
}

const DISPLAY_NAMES_BY_FIELD: Record<string, string> = {
  Gender: TENANT_TOGGLEABLE_SYSTEM_FIELDS.gender,
  Race: TENANT_TOGGLEABLE_SYSTEM_FIELDS.races,
  LinkedIn: TENANT_TOGGLEABLE_SYSTEM_FIELDS.linkedInProfile
};

export function filterQuickFilterNamesBySystemFieldVisibility(
  quickFilterNames: string[],
  visibility: TenantSystemSettings
): string[] {
  if (!visibility) return quickFilterNames;
  return quickFilterNames.filter((quickFilterName) => {
    const displayName = quickFilterName.split(' (')[0].trim();
    const fieldId = DISPLAY_NAMES_BY_FIELD[displayName];
    return isSystemFieldEnabled(fieldId, visibility);
  });
}
